// @ts-nocheck
import React, { useEffect, useLayoutEffect, useRef } from "react";
import { navigate } from "react-big-calendar/lib/utils/constants";
import * as dates from "react-big-calendar/lib/utils/dates";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Box, Tooltip } from "@mui/material";
import useStyles from "./agenda-view.style";
import homeIcon from "@iconify/icons-mdi/home-map-marker";
import palmTreeIcon from "@iconify/icons-mdi/palm-tree";
import { InlineIcon } from "@iconify/react";
import addClass from "dom-helpers/addClass";
import removeClass from "dom-helpers/removeClass";
import scrollbarSize from "dom-helpers/scrollbarSize";
import getWidth from "dom-helpers/width";
import { MyLeaveAgendaViewEventState } from "my-leave/components";
import { inRange, isToday } from "oc/utils";
import PropTypes from "prop-types";

export const MyLeaveAgendaView = ({
  accessors,
  localizer,
  components,
  length = 30,
  date,
  events,
  setContainerHeight,
  onSelectEvent,
}) => {
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  const headerRef = useRef(null);
  const dateColRef = useRef(null);
  const timeColRef = useRef(null);
  const contentRef = useRef(null);
  const tbodyRef = useRef(null);

  const renderDay = (day, events, dayKey) => {
    const { event: Event, date: AgendaDate } = components;

    events = events.filter((e) =>
      inRange(e, dates.startOf(day, "day"), dates.endOf(day, "day"), accessors),
    );

    /*
    let isCurrent =
      moment(day).format("YYYYMMDD") === moment(date).format("YYYYMMDD")
        ? "#cc0033"
        : "#212121";
    */
    return events.map((event, idx) => {
      let title = accessors.title(event);

      let dateFormatString = "MMM. D. dddd";
      if (i18n.language === "hu") {
        dateFormatString = "MMM D. dddd";
      }

      let dateLabel = moment(day)
        .locale(i18n.language)
        .format(dateFormatString);

      let first =
        idx === 0 ? (
          <td
            rowSpan={events.length}
            className="rbc-agenda-date-cell"
            style={{
              width: 160,
              verticalAlign: "top",
              paddingTop: 12,
              backgroundColor: isToday(day) ? "#F6D4DD" : "white",
            }}
          >
            {AgendaDate ? (
              <AgendaDate
                day={day}
                label={dateLabel.charAt(0).toUpperCase() + dateLabel.slice(1)}
              />
            ) : (
              dateLabel.charAt(0).toUpperCase() + dateLabel.slice(1)
            )}
          </td>
        ) : (
          false
        );

      return (
        <tr
          key={dayKey + "_" + idx}
          style={
            idx === 0
              ? { height: 45, fontSize: 16 }
              : {
                  border: "none",
                  height: 45,
                  fontSize: 16,
                }
          }
          onClick={() => onSelectEvent(event)}
          className={"rbc-agenda-row"}
        >
          {first}
          <td style={{ display: "none" }} className="rbc-agenda-time-cell">
            {timeRangeLabel(day, event)}
          </td>
          <td
            className={`rbc-agenda-event-cell`}
            style={{
              border: "none",
              width: 240,
              verticalAlign: "middle",
              cursor: "pointer",
            }}
          >
            {Event ? <Event event={event} title={title} /> : title}
          </td>
          <td
            style={{
              border: "none",
              verticalAlign: "middle",
              cursor: "pointer",
              width: 160,
            }}
          >
            <MyLeaveAgendaViewEventState event={event} />
          </td>
          <td
            style={{
              border: "none",
              verticalAlign: "middle",
              cursor: "pointer",
            }}
          >
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="flex-start"
              alignItems="center"
            >
              <Tooltip title={t(`${event?.leaveType}`)} placement="top" arrow>
                <Box paddingTop="2px">
                  {event?.leaveType === "leave" ? (
                    <InlineIcon
                      icon={palmTreeIcon}
                      height="24px"
                      style={{ color: "#4d4d4d" }}
                    />
                  ) : (
                    <InlineIcon
                      icon={homeIcon}
                      height="24px"
                      style={{ color: "#4d4d4d" }}
                    />
                  )}
                </Box>
              </Tooltip>
            </Box>
          </td>
        </tr>
      );
    }, []);
  };

  const timeRangeLabel = (day, event) => {
    let labelClass = "",
      TimeComponent = components.time,
      label = localizer.messages.allDay;

    let end = accessors.end(event);
    let start = accessors.start(event);

    if (!accessors.allDay(event)) {
      if (dates.eq(start, end)) {
        label = localizer.format(start, "agendaTimeFormat");
      } else if (dates.eq(start, end, "day")) {
        label = localizer.format({ start, end }, "agendaTimeRangeFormat");
      } else if (dates.eq(day, start, "day")) {
        label = localizer.format(start, "agendaTimeFormat");
      } else if (dates.eq(day, end, "day")) {
        label = localizer.format(end, "agendaTimeFormat");
      }
    }

    if (dates.gt(day, start, "day")) labelClass = "rbc-continues-prior";
    if (dates.lt(day, end, "day")) labelClass += " rbc-continues-after";

    return (
      <span className={labelClass.trim()}>
        {TimeComponent ? (
          <TimeComponent event={event} day={day} label={label} />
        ) : (
          label
        )}
      </span>
    );
  };

  const _adjustHeader = () => {
    if (!tbodyRef.current) return;

    let header = headerRef.current;
    let firstRow = tbodyRef.current.firstChild;

    if (!firstRow) return;

    let isOverflowing =
      contentRef.current.scrollHeight > contentRef.current.clientHeight;

    let _widths = [];
    let widths = _widths;

    _widths = [getWidth(firstRow.children[0]), getWidth(firstRow.children[1])];

    if (widths[0] !== _widths[0] || widths[1] !== _widths[1]) {
      dateColRef.current.style.width = _widths[0] + "px";
      timeColRef.current.style.width = _widths[1] + "px";
    }

    if (isOverflowing) {
      addClass(header, "rbc-header-overflowing");
      header.style.marginRight = scrollbarSize() + "px";
    } else {
      removeClass(header, "rbc-header-overflowing");
    }
  };

  let { messages } = localizer;

  let end = dates.add(date, length, "day");
  let range = dates.range(date, end, "day");

  events = events.filter((event) => inRange(event, date, end, accessors));

  events.sort((a, b) => +accessors.start(a) - +accessors.start(b));

  useEffect(() => {
    _adjustHeader();
  });

  useLayoutEffect(() => {
    if (contentRef.current) {
      setContainerHeight(contentRef.current.clientHeight + 80);
    }
  }, [setContainerHeight]);

  return (
    <div className="rbc-agenda-view">
      {events.length !== 0 ? (
        <React.Fragment>
          <table ref={headerRef} className="rbc-agenda-table">
            <thead>
              <tr>
                <th
                  className={`rbc-header ${classes.headerCell}`}
                  ref={dateColRef}
                  style={{
                    fontSize: 20,
                    fontWeight: 500,
                    letterSpacing: "0.15px",
                    display: "none",
                  }}
                >
                  {messages.date}
                </th>
                <th
                  style={{ display: "none" }}
                  className="rbc-header"
                  ref={timeColRef}
                >
                  {messages.time}
                </th>
                <th
                  className={`rbc-header ${classes.headerCell}`}
                  style={{ display: "none" }}
                >
                  {messages.event}
                </th>
              </tr>
            </thead>
          </table>
          <div className="rbc-agenda-content" ref={contentRef}>
            <table className="rbc-agenda-table">
              <tbody ref={tbodyRef}>
                {range.map((day, idx) => renderDay(day, events, idx))}
              </tbody>
            </table>
          </div>
        </React.Fragment>
      ) : (
        <span className="rbc-agenda-empty">{messages.noEventsInRange}</span>
      )}
    </div>
  );
};

MyLeaveAgendaView.propTypes = {
  events: PropTypes.array,
  date: PropTypes.instanceOf(Date),
  length: PropTypes.number.isRequired,

  selected: PropTypes.object,

  accessors: PropTypes.object.isRequired,
  components: PropTypes.object.isRequired,
  getters: PropTypes.object.isRequired,
  localizer: PropTypes.object.isRequired,
};

MyLeaveAgendaView.range = (
  start,
  { length = MyLeaveAgendaView.defaultProps.length },
) => {
  let end = dates.add(start, length, "day");
  return { start, end };
};

MyLeaveAgendaView.navigate = (date, action) => {
  switch (action) {
    case navigate.PREVIOUS:
      return dates.add(date, -1, "month");

    case navigate.NEXT:
      return dates.add(date, 1, "month");

    default:
      return date;
  }
};

MyLeaveAgendaView.title = (start, { localizer }) => {
  return localizer.format(start, "monthHeaderFormat");
};

export default MyLeaveAgendaView;
